































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { MrfiktivSnapshotSignRequestViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ISnapshotSignRequest } from "@/models/snapshot-sign-request.entity";
import { $t } from "@/lib/utility/t";

@Component({})
export default class RefsSnapshotSignRequest extends Vue
  implements IRefDetail<MrfiktivSnapshotSignRequestViewModelGen> {
  @Prop()
  item!: ISnapshotSignRequest;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  get date() {
    return simpleDoubleDigitDate(this.item.timestamp.created);
  }

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  get signerText(): string | null {
    const s = this.item.signer;
    if (!s) return null;
    const name = [s.firstName, s.lastName].filter(Boolean).join(" ");
    if (s.location) {
      return `${name} • ${s.location}`;
    }
    return name;
  }

  get titleText(): string {
    // Fallback to a readable label when no signer name
    return this.signerText || $t("objects.snapshot.signRequest.title");
  }

  get statusReadable() {
    return $t(`enums.RequestStatusEnum.${this.item.status}`);
  }

  get statusChipColor(): string {
    return this.item.statusColor || "primary";
  }

  // No dedicated route available; emit openDetail or no-op
  async goToDetail() {
    if (this.hasOpenDetailListener()) {
      this.emitOpenDetail();
    }
  }
}
